<template>
	<v-card class="flex d-flex flex-column" ripple @click="addToCart">
		<v-img height="200" :src="product.image_url"></v-img>
		<v-card-title primary-title>
			<div v-line-clamp:20="2">{{ product.name }}</div>
		</v-card-title>
		<v-card-text class="fill-height">
			<div class="my-4 text-subtitle-1 text-truncate">
				{{ product.formatted_price_after_tax }}
			</div>

			<div v-html="product.description" v-line-clamp:20="3"></div>
		</v-card-text>
		<v-card-actions>
			<v-btn block text @click="addToCart"
				><v-icon left>mdi-cart-plus</v-icon>
				{{ $t("label.add_to_cart") }}</v-btn
			>

			<v-dialog
				v-model="dialog"
				max-width="600px"
				:fullscreen="fullscreen"
				transition="dialog-bottom-transition"
			>
				<ValidationObserver ref="obs" v-slot="{ invalid }">
					<v-card>
						<v-img :src="product.image_url" height="250">
							<v-btn text @click="close" class="ma-3 float-right"
								><v-icon left>mdi-close</v-icon
								>{{ $t("Close") }}
							</v-btn>
						</v-img>
						<v-card-title primary-title>
							{{ product.name }}
							<v-spacer></v-spacer>
							<v-btn icon v-if="!fullscreen">
								<v-icon @click="fullscreen = true"
									>mdi-fullscreen</v-icon
								></v-btn
							>
							<v-btn icon v-if="fullscreen">
								<v-icon @click="fullscreen = false"
									>mdi-fullscreen-exit</v-icon
								></v-btn
							>
						</v-card-title>
						<v-divider></v-divider>
						<v-card-text class="py-0">
							<v-container grid-list-md class="py-0">
								<v-layout row wrap>
									<v-flex xs12 v-if="product.description">
										<v-subheader class="px-0">
											<strong>{{
												$t("Description")
											}}</strong>
										</v-subheader>
										<p v-html="product.description"></p>
									</v-flex>
									<v-flex
										xs12
										md12
										v-if="product.type == 'variable'"
									>
										<ValidationProvider
											name="variation_id"
											rules="required"
											v-slot="{ errors, valid }"
										>
											<v-subheader
												class="px-0"
												:class="{ 'red--text': !valid }"
											>
												<strong>{{
													$t("label.variations")
												}}</strong>
											</v-subheader>
											<v-radio-group
												v-model="item.variation_id"
												column
												:error-messages="errors"
											>
												<v-radio
													v-for="(
														variation, index
													) in product.variations"
													:label="variation.name"
													:value="variation.id"
													:key="index"
												>
													<template v-slot:label>
														<v-list-item>
															<v-list-item-content>
																<v-list-item-title>
																	{{
																		variation.name
																	}}
																</v-list-item-title>
															</v-list-item-content>
															<v-list-item-action-text>
																{{
																	variation.formatted_price_after_tax
																}}
															</v-list-item-action-text>
														</v-list-item>
													</template></v-radio
												>
											</v-radio-group>
										</ValidationProvider>
									</v-flex>
									<v-flex
										xs12
										v-if="product.extras_count > 0"
									>
										<v-subheader class="px-0 py-0">
											<strong>{{
												$t("label.extras")
											}}</strong>
										</v-subheader>
										<v-list
											class="grey lighten-5 py-0"
											dense
											rounded
										>
											<v-list-item
												class="pa-0"
												dense
												v-for="(
													extra, index
												) in product.extras"
												:key="`extra.${index}`"
											>
												<v-list-item-content>
													<v-list-item-title>{{
														extra.name
													}}</v-list-item-title>
													<v-list-item-subtitle>
														<v-btn-toggle tile>
															<v-btn
																text
																icon
																x-small
																@click="
																	minusExtra(
																		index
																	)
																"
															>
																<v-icon
																	>mdi-minus</v-icon
																>
															</v-btn>
															<v-btn
																text
																x-small
																icon
															>
																{{
																	extra.quantity
																		? extra.quantity
																		: 0
																}}
															</v-btn>
															<v-btn
																text
																icon
																x-small
																@click="
																	plusExtra(
																		index
																	)
																"
															>
																<v-icon
																	>mdi-plus</v-icon
																>
															</v-btn>
														</v-btn-toggle></v-list-item-subtitle
													>
												</v-list-item-content>
												<v-list-item-action-text>
													{{
														extra.formatted_price_after_tax
													}}
												</v-list-item-action-text>
											</v-list-item>
										</v-list>
									</v-flex>
									<v-flex xs12>
										<v-subheader class="px-0 py-0">
											<strong>{{
												$t("label.custom_request")
											}}</strong>
										</v-subheader>
										<v-textarea
											v-model="item.note"
											:placeholder="
												$t('label.custom_request')
											"
											outlined
											tile
										></v-textarea>
									</v-flex>
									<v-flex xs12>
										<v-subheader class="px-0 py-0">
											<strong>{{
												$t(
													"label.if_item_is_not_available"
												)
											}}</strong>
										</v-subheader>
										<v-select
											v-model="item.unavailable"
											outlined
											tile
											:items="unavailables"
										></v-select>
									</v-flex>
								</v-layout>
							</v-container>
						</v-card-text>
						<v-divider></v-divider>
						<v-card-actions>
							<v-container grid-list-md>
								<v-layout row wrap>
									<v-flex xs3>
										<v-select
											v-model="item.quantity"
											:items="[
												1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
											]"
											hide-details
											py-0
											my-0
											dense
											class="text-center"
											:label="$t('label.quantity')"
										></v-select>
									</v-flex>
									<v-flex xs9>
										<v-btn
											color="primary"
											:disabled="
												invalid ||
												$wait.is('adding to cart')
											"
											block
											@click="submit"
											:loading="
												$wait.is('adding to cart')
											"
										>
											<v-icon left>mdi-cart-plus</v-icon>
											{{ $t("label.add_to_cart") }}
											(${{ totalPrice }})
										</v-btn>
									</v-flex>
								</v-layout>
							</v-container>
						</v-card-actions>
					</v-card>
				</ValidationObserver>
			</v-dialog>
		</v-card-actions>
	</v-card>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
export default {
	components: {
		Link,
	},
	props: ["product", "type"],
	data() {
		return {
			dialog: false,
			fullscreen: false,
			item: {
				catalogue_product_id: this.product.catalogue_product_id,
				product_id: this.product.id,
				variation_id: null,
				quantity: 1,
				note: null,
				unavailable: "remove_item",
				extras: this.product.extras,
				instance: this.type,
				outlet_uuid: this.$route().params.outlet,
			},
		};
	},
	computed: {
		totalPrice() {
			var price_after_tax = this.product.price_after_tax;

			if (this.product.type == "variable") {
				price = 0;
			}

			return (
				(parseFloat(price_after_tax) +
					parseFloat(this.extraPrice) +
					parseFloat(this.variationPrice)) *
				this.item.quantity
			);
		},
		extraPrice() {
			var extra = 0;

			for (var i = 0; i < this.item.extras.length; i++) {
				extra +=
					parseInt(this.item.extras[i].quantity) *
					parseFloat(this.item.extras[i].price);
			}

			return extra;
		},
		variationPrice() {
			var price = 0;

			if (this.product.type == "variable") {
				var index = this.product.variations.findIndex(
					(v) => v.id === this.item.variation_id
				);
				if (index != -1) {
					price = this.product.variations[index].price;
				}
			}

			return price;
		},
		unavailables() {
			return [
				{
					value: "remove_item",
					text: this.$t("label.remove_item"),
				},
				{
					value: "cancel_order",
					text: this.$t("label.cancel_order"),
				},
				{
					value: "call_me",
					text: this.$t("label.call_me"),
				},
			];
		},
	},
	methods: {
		async addToCart() {
			try {
				this.dialog = true;
			} catch (error) {
				this.$toast.error(error.message);
			}
		},
		close() {
			this.dialog = false;
		},
		minusExtra(index) {
			if (this.product.extras[index].quantity > 0) {
				this.product.extras[index].quantity =
					parseInt(
						this.product.extras[index].quantity
							? this.product.extras[index].quantity
							: 0
					) - 1;
			}
		},
		plusExtra(index) {
			if (this.product.extras[index].quantity < 10) {
				this.product.extras[index].quantity =
					parseInt(
						this.product.extras[index].quantity
							? this.product.extras[index].quantity
							: 0
					) + 1;
			}
		},

		async submit() {
			try {
				this.$wait.start("adding to cart");
				const { data } = await axios.post(
					this.$route("shop.carts.store"),
					this.item,
					{
						params: {
							type: "catalogue",
						},
					}
				);
				if (data.success) {
					this.dialog = false;
					this.$emit("succeed");
				} else {
					this.$toast.error(data.data);
				}
			} catch (error) {
				this.$toast.error(error.message);
			} finally {
				this.$wait.end("adding to cart");
			}
		},
	},
};
</script>